const drill_fr = require('./drill.json')
export default drill_fr